import { render, staticRenderFns } from "./cpt-dataV-activeRing.vue?vue&type=template&id=30bc7e47&scoped=true"
import script from "./cpt-dataV-activeRing.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-activeRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc7e47",
  null
  
)

export default component.exports